import axios from 'Axios'
// import { hostname } from 'api/config'

// 创建axios实例
const http = axios.create({
    // baseURL: hostname.base_url_api7, // api的base_url
    timeout: 60000, // 请求超时时间
    withCredentials: true,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
})

// request拦截器
http.interceptors.request.use(config => {
    // if (config.baseURL.indexOf('http') === -1) {
    //     config.baseURL = config.baseURL.replace('//', 'http://')
    // }
    // config.headers['referer'] = config.baseURL
    return config
}, error => {
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
http.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error)
    }
)

export default http
